import Label from "./Label.vue";
import { pluginify } from "./../../util";
export default pluginify(Label);
export { Label };
